module.exports = __webpack_public_path__ + "static/img/1-2.e3ff681.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/1-2.png
// module id = Rijv
// module chunks = 0